namespace $.$$ {

	export class $shm_hitalama_color_dot extends $.$shm_hitalama_color_dot {

		transparent() {
			return this.color().trim().toLowerCase() === 'transparent'
		}

	}

}
